import cx from 'classnames';
import type { ReactElement } from 'react';
import styled from 'styled-components';

const InfoCardContainer = styled.div` 
    display: flex;
    align-items: flex-start;
    padding: 20px 14px;
    color: #2E384D;
    background-color: #ffffff;
    border: 1px solid #D5DAEA;
    border-radius: 5px;
    box-shadow: 0px 2px 9px rgba(0, 0, 0, 0.07);
    position: relative;

    .texts-section {
        min-width:
        width:100%;        
        padding-right:0px;
        display:flex;
        flex-direction:column;
        align-items:center;

        .stat-data {
            font-size:28px;
            font-weight:700;
            margin-bottom:9px;            
        }

        .title {
            font-size:11px;
            font-weight:600;
        }
        .unit {
          font-size:11px;
          font-weight:600;
        }

        .subtitle {
            font-size:8px;
            font-weight:300;
        }
    }

    .texts-section.limited-space {
        align-items:flex-start;
        max-width:135px;
    }

    .icon-section {
       width:52px;
       height:52px;
       
        .icon {
            width:100%;
            height:100%;
            background-repeat:no-repeat;
            background-size:cover;
            background-position:center center;            
        }

        .mirrored {
          -webkit-transform: scaleX(-1);
          transform: scaleX(-1);  
        }

        .thin {
            width: 70%;
        }

        .thinner {
            width: 50%;
        }

        .primary { 
          color: var(--primary);
        }

        .eye-blue {
            background-image:url(/assets/icons/Eye-blue.svg);
        }

        .user-blue {
            background-image:url(/assets/icons/User-blue.svg);
        }

        .clock-blue {
            background-image:url(/assets/icons/Clock-blue.svg);
        }

        .pie-chart-blue {
            background-image:url(/assets/icons/Pie-chart-blue.svg);
        }

        .mail-blue {
            background-image:url(/assets/icons/Mail-blue.svg);
        }

        .clapper-blue {
            background-image:url(/assets/icons/Clapper-blue.svg);
        }  
            
        .no-image {
          wdith: 10px;
        }
    }

    .custom-tooltip {
      display:none;
      justify-content:center;
      align-items:center;
      padding:14px 15px;
      background: #0C3192;
      box-shadow: 0px 16px 34px rgba(0, 0, 0, 0.08);
      border-radius: 4px;
      width:100%;
      max-width:176px;
      position:absolute;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: calc(100% + 10px);
      z-index:1;  
      text-align:center;

      .text {
        font-size:11px;
        font-weight:600;
        color:#FFFFFF;
        text-transform: initial;
        line-height: 14px;
      }

      .arrow {
        width:16px;
        height:8px;
        background:#0C3192;
        clip-path: polygon(100% 0, 0 0, 50% 100%);
        position:absolute;
        position: absolute; 
        left: 0; 
        right: 0; 
        top:100%;
        bottom: calc(100% + 10px);
        margin-left: auto; 
        margin-right: auto;
      }

    }

    &:hover .custom-tooltip
    {
      display:flex;
    }

    &.bigger-icon .icon-section{
      overflow:hidden;
      .icon{
        transform: scale(1.3);
      }
    }

`;

interface Props {
  statData?: number | string;
  title?: string;
  iconClass?: string;
  subtitle?: string;
  unit?: string;
  tooltip?: string;
  className?: string;
}

export const InfoCard = ({
  statData = 0,
  title = '',
  iconClass = '',
  subtitle = '',
  unit = '',
  tooltip = '',
  className
}: Props): ReactElement => (
  <InfoCardContainer
    style={{
      justifyContent: iconClass.length ? 'space-between' : 'center',
      width: iconClass.length ? '215px' : '130px',
      height: '98px'
    }}
    className={cx(className)}
  >

    <div className={`texts-section ${iconClass.length && 'limited-space'}`}>
      <div className='stat-data'>
        {statData} <span className='unit'>{unit}</span>
      </div>
      <div className='title'>{title}</div>
      {subtitle.length ? <div className='subtitle'>{subtitle}</div> : null}
    </div>
    {iconClass.length ? (
      <div className='icon-section'>
        <div className={`icon ${iconClass}`} />
      </div>
    ) : null}
    {tooltip.length ? (
      <div className='custom-tooltip'>
        <div className='text'>{tooltip}</div>
        <div className='arrow' />
      </div>
    ) : null}
  </InfoCardContainer>
);
